import type { Prototype } from "../prototype-types";

export const erelGililovPrototypes: Prototype[] = [
  {
    id: "eg-signup-clarity-demo",
    name: "Signup Clarity Demo",
    path: "/eg/signup-clarity-demo",
    description:
      "Demo hub for the signup clarity tickets assigned to Erel: annual sales labels, business type Other, website before business name.",
    owner: "Erel Gililov",
    createdAt: "2026-10-13",
    lastUpdated: "2026-10-13",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a4bdfb213630b7bcad528371764eee195cb3107deb8a6b5f34bdf5a92164532d.png",
  },
];
